import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map, skip } from 'rxjs/operators';

import { Colors as DarkTheme } from './../theme/dark/ts/colors';
import { Colors as LightTheme } from './../theme/light/ts/colors';

export const SupportedThemes = { light: LightTheme, dark: DarkTheme };

export type SupportedThemesT = keyof typeof SupportedThemes;
export type Theme = (typeof SupportedThemes)[SupportedThemesT];

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public static readonly DEFAULT_THEME: SupportedThemesT = 'light';
  public static resolveAppTheme(): SupportedThemesT {
    return (
      <SupportedThemesT>localStorage.getItem(ThemeService.LS_KEY) || ThemeService.DEFAULT_THEME
    );
  }
  public static setAppTheme(theme: SupportedThemesT): void {
    localStorage.setItem(ThemeService.LS_KEY, theme);
  }

  public static setThemeHTMLData(): void {
    const theme = ThemeService.resolveAppTheme();
    document.documentElement.setAttribute('data-theme', theme);
  }

  private static readonly LS_KEY: string = 'recruitee-theme';

  public theme$: Observable<Theme>;

  private supportedThemes$: BehaviorSubject<SupportedThemesT>;

  constructor() {
    this.supportedThemes$ = new BehaviorSubject(ThemeService.resolveAppTheme());
    this.theme$ = this.supportedThemes$
      .asObservable()
      .pipe(map(theme => SupportedThemes[theme] || SupportedThemes[ThemeService.DEFAULT_THEME]));
    this.supportedThemes$.pipe(skip(1)).subscribe(theme => ThemeService.setAppTheme(theme));
  }
}
